import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateOrganizationBody, CreateOrganizationResponse } from '@releve/shared';
import { authedPost } from '@/lib/api';
import { trackEvent } from '@/lib/posthog';

export function useCreateOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    // `POST /api/v1/organizations` creates the organization and enrols the
    // caller as its first admin in one transaction (`create_organization_with_owner`).
    // The timezone is required and validated server-side against pg_timezone_names.
    mutationFn: async (body: CreateOrganizationBody): Promise<CreateOrganizationResponse> => {
      const result = await authedPost<CreateOrganizationResponse>('/api/v1/organizations', body);
      if (!result?.organizationId) {
        throw new Error('No data returned from organization creation');
      }
      return result;
    },
    onSuccess: () => {
      trackEvent('organization_created', {});
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      queryClient.invalidateQueries({ queryKey: ['organization-members'] });
    },
  });
}
